import { Authority } from '@project44/ui-utils';

export const ANALYTICS_AUTHORITIES = [
  Authority.ANALTYICS_ROOT_CAUSE_ANALYSIS,
  Authority.ANALYTICS_OCEAN_SUSTAINABILITY,
  Authority.ANALYTICS_PORT_INTEL,
  Authority.ANALYTICS_TRUCKLOAD,
  Authority.ANALYTICS_OCEAN,
  Authority.ANALYTICS_VOC_USERS,
];

export const INITIATE_AUTHORITIES = [
  Authority.INITIATE_CREATE_RATED_SHIPMENTS,
  Authority.INITIATE_READ_RATED_SHIPMENTS,
  Authority.INITIATE_UPDATE_RATED_SHIPMENTS,
];

export const P44OS_AUTHORIITES = [
  Authority.P44OS_CUSTOMER_CONSUMPTION,
  Authority.P44OS_CONSUMPTION_TRENDS,
  Authority.P44OS_SCORECARD,
  Authority.P44OS_NEWSLETTER,
  Authority.P44OS_CONSUMPTION_TRENDS_ALL_TENANTS,
  Authority.P44OS_CUSTOMER_CONSUMPTION_ALL_TENANTS,
  Authority.P44OS_SCORECARD_ALL_TENANTS,
  Authority.P44OS_NEWSLETTER_ALL_TENANTS,
];
